<template>
    <div class="request-send-access-link">
        <b-container fluid v-show="sent">
          <b-row>
            <b-col cols="10" lg="11">
                <div class="panel" primary noradius>
                <h2 class="section--title">
                    Grazie!
                </h2>
                <p>
                    Ti abbiamo inviato un'email con tutte le informazioni. Controlla ora!
                </p>
                </div>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid v-show="!sent">
            <b-row>
                <b-col sm="12">
                <h4 class="section--title">
                    Inizia il percorso guidato per trovare il viaggio perfetto per te
                </h4>
                <!--
                <p class="request-copy">
                    Inizia qui il percorso guidato per trovare il viaggio perfetto per le tue esigenze
                </p>-->
                </b-col>
                <b-col sm="12">
                    <b-form-group :state="validate()">
                        <div class="checkbox">
                            <b-form-checkbox v-model="checkbox_1" :ref="'checkbox-checkbox_1_'+_uid" required type="checkbox" name="checkbox" :id="'checkbox-checkbox_1_'+_uid" />
                            <label :for="'checkbox-checkbox_1_'+_uid" class="checkbox-label">
                                Dichiaro di aver letto e di accettare l’informativa privacy fornendo il consenso al trattamento dei dati personali comunicati.
                            </label>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="request--content">
                        <b-form-group :state="validate()">
                            <b-form-group id="request-customer-email">
                                <b-form-input
                                    ref="request-customer-email"
                                    id="request-customer-email"
                                    v-model="email"
                                    type="email"
                                    placeholder="Nome"
                                    required
                                ></b-form-input>
                                <div class="formerror"></div>
                            </b-form-group>
                        </b-form-group>
                    </div>
                </b-col>
                <b-col>
                    <b-spinner v-if="loading" variant="primary" />
                    <b-button v-else variant="cta" :disabled="!can_submit" @click="request_access()">INIZIA QUI!</b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { request_send_access_link } from '@/api'
    import { validate_fields } from '@/validate'
    import { custom_event } from '@/utilities'

    export default {
        name: 'request-send-access-link',
        components: {
        },
        props:
        {
            additional_data: {
                type: Object,
                default: () => { return {} }
            },
            custom_event_action: {
              type: String,
              default: 'modal'
            }
        },
        data() {
            return {
                email: Vue.prototype.$config.integration.email,
                sent: false,
                msg: '',
                checkbox_1: false,
                can_submit: false,
                loading: false,
            }
        },
        computed: {
        },
        created()
        {
            this.validate_fields = validate_fields
        },
        mounted() {
        },
        methods:{
            validate()
            {
                if(Object.keys(this.$refs).length == 0) return false

                let validation = validate_fields([
                    {
                        ref: this.$refs['request-customer-email'],
                        type: 'emailtobeconfirmed',
                        value: this.email,
                        optional: false,
                    },
                    {
                        ref: this.$refs['checkbox-checkbox_1_'+this._uid],
                        type: 'checkbox',
                        value: this.checkbox_1,
                        optional: false,
                    },
                ])

                this.can_submit = validation
                return validation
            },

            request_access(){
                this.loading = true
                let _this = this
                request_send_access_link({
                    email: this.email,
                    additional_data: this.additional_data,
                })
                    .then(
                        (success) => {
                            this.sent = true
                            this.msg = success.data.msg
                            this.loading = false

                            if(_this.additional_data.productCode){
                              custom_event('newRequest')
                              custom_event('newRequest_fromProduct', _this.additional_data.productCode) // da prodotto invia richiesta diretta
                            }else{
                              custom_event('requestLink')
                              custom_event('requestLink_' + _this.custom_event_action)
                            }

                        },
                        (error) => {
                            this.sent = false
                            this.loading = false
                            this.log(error.status)
                        },
                    )
            },
        },
    }
</script>

<style lang="scss">
    .request-send-access-link
    {
        margin:$grid-gutter-width auto;
        max-width: calc(900px + #{$grid-gutter-width});
        .section--title
        {
            color:$tertiary;
            font-size: 28px;
        }
        .request-copy
        {
            margin-bottom:2rem;
        }
        #request-customer-email
        {
            margin-bottom:0;
        }
        .checkbox
        {
            display:flex;
            font-size: 11px;
        }
    }
</style>